export enum RoutesEnum {
  ROOT = '/',
  MY_ACCOUNT = 'my-account',
  DASHBOARD = 'dashboard',
  DETAILS = 'details',
  SETTINGS_AND_PRIVACY = 'settings-and-privacy',
  COMPANY_INFO = 'company-info',
  PERSONAL_INFO = 'personal-info',
  SEARCH_RESULT_ROOT = 'for-sale/property-type',
  LOGIN = 'login',
  REGISTER = 'register',
  ABOUT_US = 'aboutus',
  JOBS = 'careers/',
  CONTACT = 'page/contact-us',
  SITEMAP = 'sitemap/flow',
  TERMS = 'page/terms',
  UPDATE_NAME = 'update-name',
  MANAGE_CONTACT = 'manage-contact',
  UPDATE_EMAIL = 'update-email',
  UPDATE = 'update',
  UPDATE_PASSWORD = 'update-password',
  UPDATE_PHONE_NUMBER = 'update-phone-number',
  UPDATE_COMPANY = 'update',
  LISTING = 'listing',
  MY_LISTING = 'my-listings',
  INITIALIZE = 'initialize',
  EDIT = 'edit',
  PHOTOS = 'photos',
  PUBLISH = 'publish',
  CHECKOUT = 'checkout',
  USER_CARDS = 'user-cards',
  USER_ADD_CARD = 'add-card',
  SUBSCRIPTION = 'subscription',
  USER_SUBSCRIPTION = 'user-subscription',
  AQAR_CONNECT = 'aqar-connect/',
  CONNECT_REQUESTS = 'dashboard/aqar-connect?active=1',
  AQAR_CONNECT_SEGMENT = 'aqar-connect/segment',
  PRICE = 'price',
  ACTIVITIES = 'activities',
  FAVORITES = 'favorites',
  USER_FAVORITES = 'user/favorites/:id',
  USER_FAVORITES_SHARED_NOTES = 'shared-notes',
  USER_FAVORITES_SHARED = 'shared',
  PACKAGES = 'packages',
  FEATURE = 'feature',
  LEAD_FOLLOW_UP = 'lead-follow-up',
}
